import { Serializer } from '@core/resources/serializer';
import { Category } from '../category/category';
import { LANGUAGE_I18N_2_THEME } from '../language.maps';
import { Theme, ThemeIO } from './theme';

export class ThemeSerializer implements Serializer<Theme> {
  private _lang: string;
  private _langMap = LANGUAGE_I18N_2_THEME;

  constructor(lang: string) {
    this._lang = lang;
  }

  fromJson(json: ThemeIO): Theme {
    return new Theme(json, this._lang);
  }

  toJson(theme: Theme): ThemeIO {
    return {
      id: theme.id,
      languages: [{language: this._langMap[this._lang], label: theme.name, badge: theme.badge}],
      categories: theme.categories.map((cat: Category) => cat.toJson())
    };
  }
}
